import { useState } from "react";
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import { DailogMain, SiteSettingModalContainer, TagsTitle } from "../MapStyled";
import { CircleBtn } from "assets/css/globle";
import { useHookstate } from "@hookstate/core";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { SiteSetupAction } from "globalStore/globalStore";
import { siteSettingsTypes } from "constant";

const COGAndTeeAndPOIAddPopup = ({
  sitesetupDialogBox,
  courseName,
  HoleNo,
  holeCount,
  teeValue,
  addCogDistan,
  poiTypeValue,
  poiPositionValue,
  addCogTeePoiSaveActiveButton,
  cancelDialogOpen,
  saveMarkers,
  setCourseName,
  setHoleCount,
  setHoleNo,
  setAddCogTeePoiSaveActiveButton,
  setTeeValue,
  setPoiTypeValue,
  setPoiPositionValue
}) => {
  const { addSelectType } = useHookstate(SiteSetupAction);
  const { siteSettingsData, siteSetupData } =
    useSelector((state) => state.commonReducers) || [];
  const { t } = useTranslation();

  const [tempAreaPopupinitial, setTempAreaPopupinitial] = useState({
    site: null,
    hole: null,
    type: null,
  });

  const handleChange = (event) => {
    setCourseName(event.target.value);
    let data = siteSettingsData.Courses;
    let obj = data.find((o) => o.Number === event.target.value);
    let holeNumber = obj?.HoleCount;

    setHoleCount(holeNumber);
  };

  const handleChange2 = (event) => {
    setHoleNo(event.target.value);
  };

  const teeHandleChange = (e) => {
    if (tempAreaPopupinitial.type === null)
      setTempAreaPopupinitial({ ...tempAreaPopupinitial, type: teeValue });
    else setAddCogTeePoiSaveActiveButton(false);
    setTeeValue(e.target.value);
  };

  const poiHandleChange = (e) => {
    setAddCogTeePoiSaveActiveButton(true);
    setPoiTypeValue(e.target.value);
  };

  const poiPositionHandleChange = (e) => {
    setAddCogTeePoiSaveActiveButton(true);
    setPoiPositionValue(e.target.value);
  };

  return (
    <DailogMain
      style={{
        position: `${sitesetupDialogBox.position}`,
        top: `${sitesetupDialogBox.top}`,
        left: `${sitesetupDialogBox.left}`,
      }}
    >
      <SiteSettingModalContainer>
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {t("Add_Site_Setting")}
        </DialogTitle>

        <DialogContent>
          <DialogContentText>{t("Select_Course")}</DialogContentText>
          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={courseName}
              onChange={(e) => handleChange(e)}
            >
              {siteSettingsData &&
                siteSettingsData?.Courses?.map((item) => (
                  <MenuItem key={item?.Number} value={item?.Number}>
                    {item?.Name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogContent>
          <DialogContentText>{t("Select_Hole")}</DialogContentText>

          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={HoleNo}
              onChange={(e) => handleChange2(e)}
            >
              {holeCount !== null &&
                [...Array(holeCount)].map((elementInArray, index) => (
                  <MenuItem key={index + 1} value={index + 1}>{index + 1}</MenuItem>
                ))}
            </Select>
          </FormControl>
        </DialogContent>

        {addSelectType.get() === siteSettingsTypes.teeMarkers ? (
          <DialogContent>
            <DialogContentText>{t("Select_Tee")}</DialogContentText>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={teeValue}
                defaultValue={teeValue}
                onChange={(e) => teeHandleChange(e)}
              >
                {siteSetupData.TeeMarkerSettings.map((item, i) => (
                  <MenuItem key={i} value={item.Id}>
                    {item.Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TagsTitle>Distance (CoG): {addCogDistan} yd</TagsTitle>
          </DialogContent>
        ) : (
          <></>
        )}
        {addSelectType.get() === siteSettingsTypes.pointOfInterest ? (
          <DialogContent>
            <DialogContentText>{t("Select_Type")}</DialogContentText>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={poiTypeValue}
                defaultValue={poiTypeValue}
                onChange={(e) => poiHandleChange(e)}
              >
                <MenuItem value={2}>{t("Hole")}</MenuItem>
                <MenuItem value={3}>{t("Approach")}</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
        ) : (
          <></>
        )}
        {addSelectType.get() === siteSettingsTypes.pointOfInterest ? (
          <DialogContent>
            <DialogContentText>{t("Select_Position")}</DialogContentText>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={poiPositionValue}
                defaultValue={poiPositionValue}
                onChange={(e) => poiPositionHandleChange(e)}
              >
                <MenuItem value={0}>{t("Left")}</MenuItem>
                <MenuItem value={1}>{t("Right")}</MenuItem>
                <MenuItem value={2}>{t("Above")}</MenuItem>
                <MenuItem value={3}>{t("Below")}</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
        ) : (
          <></>
        )}
        <DialogActions>
          <CircleBtn
            disabled={!addCogTeePoiSaveActiveButton}
            onClick={() => {
              saveMarkers();
            }}
            className={addCogTeePoiSaveActiveButton ? "active" : "disabled"}
          >
            {t("Save")}
          </CircleBtn>
          <CircleBtn onClick={() => cancelDialogOpen("cancelMarkers")}>
            {t("Cancel")}
          </CircleBtn>
        </DialogActions>
      </SiteSettingModalContainer>
    </DailogMain>
  );
};

export default COGAndTeeAndPOIAddPopup;
